

export const JSON_LD_SCHEMA = 'https://schema.org'

export const JSON_LD_ORGANIZATION_ID = 'srp-organization-json-ld'
